var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56487 15.7163L9.50498 5.32018C10.6927 3.54106 13.3075 3.54106 14.4952 5.32018L21.4353 15.7163C22.7661 17.7098 21.3371 20.382 18.9402 20.382H5.05998C2.66305 20.382 1.23405 17.7098 2.56487 15.7163ZM12.4049 9.00338H11.5951C11.0071 9.00338 10.546 9.50834 10.5992 10.094L10.9173 13.5906C10.9642 14.1057 11.396 14.5 11.9132 14.5H12.0869C12.604 14.5 13.0359 14.1057 13.0828 13.5906L13.4008 10.094C13.4541 9.50834 12.993 9.00338 12.4049 9.00338ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "#12284A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.0336b5a28961b8d657b39b598d36515e.svg";
export { ForwardRef as ReactComponent };